




























































































































































































import { computed, defineComponent, PropType, ref, onBeforeUnmount } from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import { app, alarm } from "@/store";

export default defineComponent({
    components: {
        SensorHeader: () => import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
        SensorModule: () => import(/* webpackChunkName: "components" */ "./SensorModule.vue"),
        ConfirmDialog: () => import(/* webpackChunkName: "settings" */ "@/views/components/Dialogs/ConfirmDialog.vue")
    },
    props: {
        value: Object as PropType<AttachedDeviceModel>
    },
    setup(_, { attrs }) {
        const showResetConfirm = ref(false);
        const showRestartConfirm = ref(false);
        const showNotAllowed = ref(false);
        let timer: number | null = null;

        // Li-ion thresholds
        const smallVoltageLimit = 0.5;
        const lowVoltageLimitLiIon = 3.3;
        const highVoltageLimitLiIon = 4.0;

        const voltage = computed<number>(() => {
            return alarm.alarmStatus &&
                alarm.alarmStatus.VSupplies &&
                alarm.alarmStatus.VSupplies[0]
                ? getVoltage(alarm.alarmStatus.VSupplies[0].V3)
                : -1;
        });

        const voltageDisplay = computed(() =>
            voltage.value >= 0 ? `${voltage.value.toFixed(2)} V` : "Not present"
        );

        const batteryPct = computed<number>(() => {
            if (voltage.value < 0) return 0;
            const pct = ((voltage.value - lowVoltageLimitLiIon) / (highVoltageLimitLiIon - lowVoltageLimitLiIon)) * 100;
            return Math.max(0, Math.min(100, pct));
        });

        // Color map for voltage chip & bar (success / warning / error)
        const voltageColor = computed<string>(() => {
            const v = voltage.value;
            if (v < 0) return "grey";       // not present
            if (v <= 3.5 || v >= 4.35) return '#c20e1a';        // red
            if ((v > 3.5 && v < 3.7) || v > 4.25) return '#ffcc00'; // orange
            return '#81b13e';               // green
        });

        const boatPower = computed<boolean>(() => {
            if (alarm.alarmStatus && alarm.alarmStatus.VSupplies && alarm.alarmStatus.VSupplies[0]) {
                const v = alarm.alarmStatus.VSupplies[0].V1;
                return v !== "N/A";
            }
            return false;
        });

        // Mirror GSM/Cloud for now; wire real flags when available
        const gsmCloud = computed<boolean>(() => true);
        const cloudConnected = computed<boolean>(() => gsmCloud.value);

        const gpsConnected = computed<boolean>(() => {
            return !!(alarm.lastKnownLocation && alarm.lastKnownLocation.location && alarm.lastKnownLocation.location.gps_lock);
        });

        function getVoltage(value: string | undefined): number {
            if (value === "NotPresent") return -1;
            const parsed = parseFloat(value != null ? value : "-1");
            return parsed < smallVoltageLimit ? -1 : parsed;
        }

        // Actions & guards
        const notAllowedOk = () => (showNotAllowed.value = false);

        const initReset = () => {
            if (alarm.armed) { showNotAllowed.value = true; return; }
            showResetConfirm.value = true;
        };
        const initRestart = () => {
            if (alarm.armed) { showNotAllowed.value = true; return; }
            showRestartConfirm.value = true;
        };

        const reset = () => {
            app.processingLabel = "Restoring MarineOne to factory settings...";
            app.isProcessing = true;
            app.countdown = 30;
            alarm.reset();
            showResetConfirm.value = false;

            timer = window.setInterval(() => {
                app.countdown--;
                if (app.countdown <= 0) {
                    clearInterval(timer!);
                    app.isProcessing = false;
                    window.location.reload();
                }
            }, 1000);
        };

        const restart = () => {
            app.processingLabel = "Restarting MarineOne...";
            app.isProcessing = true;
            app.countdown = 30;
            alarm.restart();
            showRestartConfirm.value = false;

            timer = window.setInterval(() => {
                app.countdown--;
                if (app.countdown <= 0) {
                    clearInterval(timer!);
                    app.isProcessing = false;
                    window.location.reload();
                }
            }, 1000);
        };

        const isActive = computed<boolean>(() => (attrs.isActive == null ? false : true));

        onBeforeUnmount(() => { if (timer !== null) clearInterval(timer); });

        return {
            alarm,
            // dialogs
            showResetConfirm, showRestartConfirm, showNotAllowed,
            // actions
            reset, restart, initReset, initRestart, notAllowedOk,
            // battery
            voltage, voltageDisplay, batteryPct, voltageColor,
            // connections
            boatPower, gsmCloud, cloudConnected, gpsConnected,
            // panel
            isActive
        };
    }
});
